// Daybreak logo mark — rising sun over a horizon. Primary strokes follow the
// theme; the sun rays keep the brand greens. Purely decorative (aria-hidden).
export function LogoMark({
  size = 30,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 280 280"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <circle
        cx="140"
        cy="140"
        r="118"
        stroke="hsl(var(--primary))"
        strokeWidth="12"
      />
      <path d="M100,162 A40,40 0 0 1 180,162" fill="#2E9E6E" />
      <line x1="140" y1="114" x2="140" y2="99" stroke="#2E9E6E" strokeWidth="7" strokeLinecap="round" />
      <line x1="167.5" y1="122.7" x2="176.1" y2="110.4" stroke="#2E9E6E" strokeWidth="7" strokeLinecap="round" />
      <line x1="112.5" y1="122.7" x2="103.9" y2="110.4" stroke="#2E9E6E" strokeWidth="7" strokeLinecap="round" />
      <line x1="182.4" y1="139.5" x2="195.6" y2="132.4" stroke="#2E9E6E" strokeWidth="7" strokeLinecap="round" />
      <line x1="97.6" y1="139.5" x2="84.4" y2="132.4" stroke="#2E9E6E" strokeWidth="7" strokeLinecap="round" />
      <line x1="60" y1="162" x2="220" y2="162" stroke="hsl(var(--primary))" strokeWidth="9" strokeLinecap="round" />
      <line x1="86" y1="182" x2="194" y2="182" stroke="#8FB9A6" strokeWidth="8" strokeLinecap="round" />
    </svg>
  );
}
